import { IPartnerDeclaration, IPartnerDeclarationPersistence } from '../interfaces';

export class PartnerDeclarationMapper {
  public static toDomain(p: IPartnerDeclarationPersistence): IPartnerDeclaration {
    return {
      id: p.id,
      user: { id: p.user_id, name: p.user_name },
      partner: { id: p.partner_id ?? 0, name: p.partner_name ?? '' },
      trackCode: p.track_code,
      globalTrackCode: p.global_track_code,
      status: { id: p.state_id, name: p.state_name },
      flight: p.flight_id ? { id: p.flight_id, name: p.flight_name ?? '' } : null,
      box: p.container_id ? { id: p.container_id, name: p.container_name ?? '' } : null,
      lastBox: p.container_id_tmp ? { id: p.container_id_tmp, name: p.container_name_tmp ?? '' } : null,
      branch: p.branch_id ? { id: p.branch_id, name: p.branch_name ?? '' } : null,
      weight: p.weight ? parseFloat(p.weight) : null,
      price: p.price ? parseFloat(p.price) : null,
      deliveryPrice: p.delivery_price ? parseFloat(p.delivery_price) : null,
      quantity: p.quantity ?? 1,
      type: p.type === 1 ? 'liquid' : 'other',
      planCategory: p.tariff_category_id ? { id: p.tariff_category_id, name: p.tariff_category_name ?? '' } : null,
      shop: p.shop_name ?? '',
      productType: p.product_type_id ? { id: p.product_type_id, name: p.product_type_name ?? '' } : null,
      parcel: p.box ? { id: p.box } : null,
      basket: p.basket_id ? { id: p.basket_id, name: p.basket_name ?? '' } : null,
      voen: p.voen ?? null,
      wardrobeNumber: p.wardrobe_number ?? '',
      editedBy: p.causer_id ? { id: p.causer_id, name: p.causer_name ?? '' } : null,
      document: p.document_file ?? null,
      file: p.document_file ?? null,
      read: !!p.is_new,
      paid: !!p.payed,
      approved: !!p.customs,
      returned: !!p.return,
      height: p.height ? parseFloat(p.height) : null,
      width: p.width ? parseFloat(p.width) : null,
      depth: p.depth ? parseFloat(p.depth) : null,
      description: p.descr ?? null,
      countryId: p.country_id ?? 0,
      customs: p.customs ?? 0,
      createdAt: p.created_at,
    };
  }
}
